// Hook: met à jour le titre du document en fonction de l'offre
// Utilisation: useDocumentTitle(offerTitle, pageTitle)
import { useEffect } from 'react';

export function useDocumentTitle(offerTitle: string | null, pageTitle: string) {
  useEffect(() => {
    const title = offerTitle ? `${offerTitle} - Candidature` : `${pageTitle} - K‑SCAN`;
    document.title = title;
  }, [offerTitle, pageTitle]);
}

